import React, { useState } from "react";
import firebase from "firebase";
import { useHistory } from "react-router-dom";
import Drawer from "../Drawer";
import "./style.scss";

const Navbar = (props) => {
  const [isOpen, setOpen] = useState(false);
  const history = useHistory();
  const handleClickNav = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleClickSignOut = () => {
    firebase
      .auth()
      .signOut()
      .then(
        function () {},
        function (error) {
          console.error("Sign Out Error", error);
        }
      );
    localStorage.clear();
    setOpen(false);
    history.push("/");
  };

  const handleClickSignIn = () => {
    setOpen(false);
    history.push("/signin");
  };

  return (
    <>
      <div>
        <img
          alt="nav"
          className="navbutton"
          src={require("./../../assets/images/nav.svg")}
          onClick={handleClickNav}
          hidden={isOpen}
        ></img>
        <Drawer
          show={isOpen}
          handleClickClose={handleClickClose}
          handleClickSignIn={handleClickSignIn}
          handleClickSignOut={handleClickSignOut}
          backdrop={props.backdrop}
        />
      </div>
    </>
  );
};

export default Navbar;
